import { message } from "antd";

export const handleCopy = (walletAddress) => {
  navigator.clipboard
    .writeText(walletAddress)
    .then(() => {
      message.success("Copied to clipboard!"); // Success message
    })
    .catch(() => {
      message.error("Failed to copy! "); // Error message
    });
};

export const formatDateTime = (recDate) => {
  const date = new Date(recDate);

  const formattedDate = date.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });

  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return `${formattedDate} | ${formattedTime}`;
};
